export function consumeSessionStorageItem(key: string): string | undefined {
	const value = sessionStorage.getItem(key) ?? undefined;

	sessionStorage.removeItem(key);

	return value;
}
